export default __webpack_public_path__ + "static/media/twitter.b90b3e3a.svg";